// extracted by mini-css-extract-plugin
module.exports = {"customLink":"CustomLink_customLink__QJYHJ"};